import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon, ShieldCheckIcon, ZapIcon, UsersIcon, LockIcon, ArrowRightIcon, RefreshCwIcon, StarIcon, ClockIcon, FlameIcon } from 'lucide-react';
function useCountdown(initialMinutes: number, initialSeconds: number) {
  const [time, setTime] = useState({
    m: initialMinutes,
    s: initialSeconds
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          m: prev.m - 1,
          s: 59
        };
        return {
          m: 14,
          s: 59
        };
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  return time;
}
export function CheckoutSection() {
  const checkoutUrl = 'https://docentes2.edulabs.online/cart/43119191818358:1';
  const {
    m,
    s
  } = useCountdown(14, 37);
  const pad = (n: number) => String(n).padStart(2, '0');
  const includes = ['Elementary Lesson Plans', 'Middle & High School Plans', 'Warm-Up Activity Bank (30+)', 'Complete Production Projects', 'Editable Script Templates', 'Lifetime Updates Included'];
  return <section className="py-12 md:py-20 bg-gray-950" id="buy" data-id="element-37">
      <div className="container mx-auto px-4" data-id="element-38">
        <div className="max-w-xl mx-auto" data-id="element-39">
          {/* Section label */}
          <p className="text-center text-orange-400 font-black text-xs uppercase tracking-widest mb-3" data-id="element-40">
            🎭 Special Launch Price
          </p>
          <h2 className="text-center text-3xl md:text-4xl font-serif font-bold text-white mb-8 leading-tight" data-id="element-41">
            Get the Complete Toolkit
            <br data-id="element-42" />
            <span className="text-orange-400" data-id="element-43">Before the Price Goes Up</span>
          </h2>

          {/* Card */}
          <div className="rounded-2xl overflow-hidden shadow-2xl shadow-black/40 border border-white/10" data-id="element-44">
            {/* Urgency bar */}
            <div className="bg-red-600 px-4 py-2.5 flex items-center justify-between" data-id="element-45">
              <span className="flex items-center gap-1.5 text-white text-xs font-bold" data-id="element-46">
                <FlameIcon className="w-3.5 h-3.5 animate-pulse" data-id="element-47" />
                Flash Sale ends in:
              </span>
              <span className="bg-white text-red-600 font-black px-3 py-0.5 rounded text-sm tabular-nums tracking-widest" data-id="element-48">
                {pad(m)}:{pad(s)}
              </span>
              <span className="flex items-center gap-1 text-white/80 text-xs" data-id="element-49">
                <span className="w-1.5 h-1.5 bg-green-400 rounded-full animate-pulse" data-id="element-50"></span>
                <UsersIcon className="w-3 h-3" data-id="element-51" />
                <span data-id="element-52">
                  <strong className="text-white" data-id="element-53">47</strong> viewing
                </span>
              </span>
            </div>

            {/* Card body */}
            <div className="bg-white p-6 md:p-8" data-id="element-54">
              {/* Stars + title */}
              <div className="flex items-center gap-1 mb-2" data-id="element-55">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-56" />)}
                <span className="text-xs text-gray-400 ml-1 font-medium" data-id="element-57">
                  2,400+ happy teachers
                </span>
              </div>

              <h3 className="text-xl md:text-2xl font-serif font-bold text-gray-900 mb-1 leading-snug" data-id="element-58">
                Drama Teacher's Complete Toolkit
              </h3>
              <p className="text-sm text-gray-500 mb-5" data-id="element-59">
                Open, print, and teach — zero prep required.
              </p>

              {/* Includes grid */}
              <div className="bg-gray-50 rounded-xl p-4 mb-5" data-id="element-60">
                <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-3" data-id="element-61">
                  What's inside:
                </p>
                <ul className="grid grid-cols-2 gap-x-3 gap-y-2" data-id="element-62">
                  {includes.map(item => <li key={item} className="flex items-center gap-1.5 text-xs text-gray-700 font-medium" data-id="element-63">
                      <CheckCircle2Icon className="w-3.5 h-3.5 text-green-500 flex-shrink-0" data-id="element-64" />
                      {item}
                    </li>)}
                </ul>
              </div>

              {/* Price row */}
              <div className="mb-1 text-center" data-id="element-65">
                {/* Original price above */}
                <div className="flex items-center justify-center gap-2 mb-1" data-id="element-66">
                  <span className="text-gray-400 line-through text-base font-medium" data-id="element-67">
                    $39.00 USD
                  </span>
                  <span className="bg-green-500 text-white text-xs font-black px-2 py-0.5 rounded-lg" data-id="element-68">
                    SAVE 67%
                  </span>
                </div>
                {/* Main price */}
                <span className="md:text-5xl font-black text-gray-900 tracking-tight text-[48px]" data-id="element-69">
                  $12.99{' '}
                  <span className="text-xl font-bold text-gray-500" data-id="element-70">USD</span>
                </span>
              </div>

              {/* Scarcity */}
              <p className="flex items-center justify-center gap-1.5 text-red-500 text-xs font-bold mb-5 mt-1" data-id="element-71">
                <ClockIcon className="w-3.5 h-3.5 flex-shrink-0" data-id="element-72" />
                Only <strong data-id="element-73">7 spots left</strong> at this price
              </p>

              {/* CTA */}
              <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="block" data-id="element-74">
                <button className="w-full bg-orange-500 hover:bg-orange-400 active:scale-[0.98] text-white font-black text-lg py-4 rounded-xl shadow-lg shadow-orange-200 transition-all duration-150 flex items-center justify-center gap-2" data-id="element-75">
                  Yes! I Want Instant Access
                  <ArrowRightIcon className="w-5 h-5" data-id="element-76" />
                </button>
              </a>

              <p className="text-center text-[11px] text-gray-400 mt-2 flex items-center justify-center gap-1" data-id="element-77">
                <LockIcon className="w-3 h-3" data-id="element-78" />
                Secure payment · Instant download · No subscription
              </p>

              {/* Trust row */}
              <div className="flex items-center justify-center gap-5 mt-4 pt-4 border-t border-gray-100 flex-wrap" data-id="element-79">
                <span className="flex items-center gap-1 text-[11px] text-gray-500 font-medium" data-id="element-80">
                  <ShieldCheckIcon className="w-4 h-4 text-green-500" data-id="element-81" />
                  7-Day Guarantee
                </span>
                <span className="flex items-center gap-1 text-[11px] text-gray-500 font-medium" data-id="element-82">
                  <ZapIcon className="w-4 h-4 text-amber-500" data-id="element-83" />
                  Instant Access
                </span>
                <span className="flex items-center gap-1 text-[11px] text-gray-500 font-medium" data-id="element-84">
                  <RefreshCwIcon className="w-4 h-4 text-blue-500" data-id="element-85" />
                  Lifetime Updates
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}